<script setup>
import useGolfWeatherIntegration from "@/scripts/Utilities/GolfWeatherIntegrationView";
import SearchableSelect from "@/components/SearchableSelectComponent.vue";

const {
  targetCourse,
  courses,
  loadingSetup,
  setupIntegration,
  targetGolfWeatherId,
  golfWeatherIdLastUpdated,
} = useGolfWeatherIntegration();
</script>

<template>
  <div class="container-fluid">
    <div class="row mb-4">
      <div class="col-12">
        <h1>Golf Weather Integration</h1>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 mb-3">
        <div class="card h-100">
          <div class="card-header">
            <h5 class="card-title">Course Selection and Golf Weather ID</h5>
          </div>
          <div class="card-body">
            <div class="mb-3">
              <label class="form-label">Select Course</label>
              <SearchableSelect
                v-model="targetCourse"
                :options="courses"
                :label="'name'"
                :trackBy="'id'"
                :placeholder="'Select the course'"
              />
            </div>
            <div>
              <label class="form-label">Input Golf Weather ID</label>
              <input
                v-model="targetGolfWeatherId"
                type="text"
                class="form-control"
                placeholder="Enter Golf Weather ID"
              />
            </div>
            <small v-if="golfWeatherIdLastUpdated">
              Last Updated: {{ golfWeatherIdLastUpdated }}
            </small>
            <small v-else-if="targetCourse && !targetGolfWeatherId">
              Golf Weather ID has not been set for this course.
            </small>
            <small v-else-if="targetCourse && golfWeatherIdLastUpdated === ''">
              No previous update on Golf Weather ID for this course.
            </small>
            <div class="mt-3">
              <button
                type="button"
                class="btn btn-success mt-2"
                :disabled="!targetCourse || !targetGolfWeatherId"
                @click="setupIntegration"
              >
                <i v-if="loadingSetup" class="fas fa-spinner fa-spin fa-lg"></i>
                Setup Golf Weather Integration
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.card {
  margin-bottom: 1rem;
}
.container-fluid {
  padding: 20px;
}

.row {
  margin-left: 0;
  margin-right: 0;
}

.col-md-6 {
  padding: 0 0.5rem;
}
</style>
